// import { useMemo, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import PropTypes from "prop-types";

// const NavBarHome = ({
//   className = "",
//   navBarHomeWidth,
//   navBarHomePosition,
//   navBarHomeTop,
//   navBarHomeLeft,
//   navBarHomeAlignSelf,
// }) => {
//   const navBarHomeStyle = useMemo(() => {
//     return {
//       width: navBarHomeWidth,
//       position: navBarHomePosition,
//       top: navBarHomeTop,
//       left: navBarHomeLeft,
//       alignSelf: navBarHomeAlignSelf,
//     };
//   }, [
//     navBarHomeWidth,
//     navBarHomePosition,
//     navBarHomeTop,
//     navBarHomeLeft,
//     navBarHomeAlignSelf,
//   ]);

//   const navigate = useNavigate();

//   const onHomeClick = useCallback(() => {
//     navigate("/");
//   }, [navigate]);

//   const onAboutUsTextClick = useCallback(() => {
//     navigate("/about-us");
//   }, [navigate]);

//   const onServicesTextClick = useCallback(() => {
//     navigate("/services");
//   }, [navigate]);

//   const onCareersTextClick = useCallback(() => {
//     navigate("/careers");
//   }, [navigate]);

//   const onButtonClick = useCallback(() => {
//     navigate("/get-in-touch");
//   }, [navigate]);

//   return (
//     <div
//       className={`w-[1690px] max-w-full flex border-b-2 flex-row items-center justify-between px-4 text-left text-13xl text-deepskyblue-200 font-istok-web ${className}`}
//       style={navBarHomeStyle}
//     >
//       <img
//         className="w-[300px] relative h-24 object-cover cursor-pointer"
//         alt=""
//         src="/logo@2x.png"
//         onClick={onHomeClick}
//       />
//       <div className="flex flex-row items-center justify-end gap-[45px]">
//         <b
//           className="relative inline-block [text-shadow:0.1px_0_0_#11a7da,_0_0.1px_0_#11a7da,_-0.1px_0_0_#11a7da,_0_-0.1px_0_#11a7da] cursor-pointer"
//           onClick={onHomeClick}
//         >
//           Home
//         </b>
//         <b
//           className="relative inline-block [text-shadow:0.1px_0_0_#11a7da,_0_0.1px_0_#11a7da,_-0.1px_0_0_#11a7da,_0_-0.1px_0_#11a7da] cursor-pointer"
//           onClick={onAboutUsTextClick}
//         >
//           About Us
//         </b>
//         <b
//           className="relative inline-block [text-shadow:0.1px_0_0_#11a7da,_0_0.1px_0_#11a7da,_-0.1px_0_0_#11a7da,_0_-0.1px_0_#11a7da] cursor-pointer"
//           onClick={onServicesTextClick}
//         >
//           Services
//         </b>
//         <b
//           className="relative inline-block [text-shadow:0.1px_0_0_#11a7da,_0_0.1px_0_#11a7da,_-0.1px_0_0_#11a7da,_0_-0.1px_0_#11a7da] cursor-pointer"
//           onClick={onCareersTextClick}
//         >
//           Careers
//         </b>
//         <button
//           className="rounded-3xs bg-gray-100 px-4 py-2 text-6xl text-gainsboro-100 cursor-pointer [text-shadow:0.1px_0_0_#e5e5e5,_0_0.1px_0_#e5e5e5,_-0.1px_0_0_#e5e5e5,_0_-0.1px_0_#e5e5e5]"
//           onClick={onButtonClick}
//         >
//           Get in Touch
//         </button>
//       </div>
//     </div>
//   );
// };

// NavBarHome.propTypes = {
//   className: PropTypes.string,

//   /** Style props */
//   navBarHomeWidth: PropTypes.string,
//   navBarHomePosition: PropTypes.string,
//   navBarHomeTop: PropTypes.string,
//   navBarHomeLeft: PropTypes.string,
//   navBarHomeAlignSelf: PropTypes.string,
// };

// export default NavBarHome;

import { useMemo, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { RxHamburgerMenu } from "react-icons/rx";

const NavBarHome = ({
  className = "",
  navBarHomeWidth,
  navBarHomePosition,
  navBarHomeTop,
  navBarHomeLeft,
  navBarHomeAlignSelf,
}) => {
  const [showMenu, setShowMenu] = useState(false);

  const navBarHomeStyle = useMemo(() => {
    return {
      width: navBarHomeWidth,
      position: navBarHomePosition,
      top: navBarHomeTop,
      left: navBarHomeLeft,
      alignSelf: navBarHomeAlignSelf,
    };
  }, [
    navBarHomeWidth,
    navBarHomePosition,
    navBarHomeTop,
    navBarHomeLeft,
    navBarHomeAlignSelf,
  ]);

  const navigate = useNavigate();

  const onHomeClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutUsTextClick = useCallback(() => {
    navigate("/about-us");
  }, [navigate]);

  const onServicesTextClick = useCallback(() => {
    navigate("/services");
  }, [navigate]);

  const onCareersTextClick = useCallback(() => {
    navigate("/careers");
  }, [navigate]);

  const onButtonClick = useCallback(() => {
    navigate("/get-in-touch");
  }, [navigate]);

  return (
    <div
      className={`relative flex justify-between items-center lg:flex lg:flex-row lg:items-center lg:justify-between text-deepskyblue-200 lg:font-istok-web px-4 ${className}`}
      // style={navBarHomeStyle}
    >
      <img
        className="w-[300px] relative h-24 object-cover cursor-pointer"
        alt=""
        src="/logo@2x.png"
        onClick={onHomeClick}
      />

      <div className="hidden lg:flex flex-row items-center justify-end gap-[45px]">
        <b
          className="text-6xl [text-shadow:0.1px_0_0_#11a7da,_0_0.1px_0_#11a7da,_-0.1px_0_0_#11a7da,_0_-0.1px_0_#11a7da] cursor-pointer"
          onClick={onHomeClick}
        >
          Home
        </b>
        <b
          className="text-6xl [text-shadow:0.1px_0_0_#11a7da,_0_0.1px_0_#11a7da,_-0.1px_0_0_#11a7da,_0_-0.1px_0_#11a7da] cursor-pointer"
          onClick={onAboutUsTextClick}
        >
          About Us
        </b>
        <b
          className="text-6xl [text-shadow:0.1px_0_0_#11a7da,_0_0.1px_0_#11a7da,_-0.1px_0_0_#11a7da,_0_-0.1px_0_#11a7da] cursor-pointer"
          onClick={onServicesTextClick}
        >
          Services
        </b>
        <b
          className="text-6xl [text-shadow:0.1px_0_0_#11a7da,_0_0.1px_0_#11a7da,_-0.1px_0_0_#11a7da,_0_-0.1px_0_#11a7da] cursor-pointer"
          onClick={onCareersTextClick}
        >
          Careers
        </b>
        <button
          className="rounded-3xs bg-gray-100 px-4 py-2 text-3xl text-gainsboro-100 cursor-pointer [text-shadow:0.1px_0_0_#e5e5e5,_0_0.1px_0_#e5e5e5,_-0.1px_0_0_#e5e5e5,_0_-0.1px_0_#e5e5e5]"
          onClick={onButtonClick}
        >
          Get in Touch
        </button>
      </div>

      <div className="flex lg:hidden">
        <button
          className="flex bg-white border"
          style={{ padding: "12px", borderRadius: "8px" }}
          onClick={() => setShowMenu(!showMenu)}
        >
          <RxHamburgerMenu size={20} />
        </button>

        {showMenu && (
          <ul className="absolute text-center top-full left-0 w-full bg-white shadow-md py-2 list-none z-50 m-0">
            <li className="text-6xl py-2 cursor-pointer" onClick={onHomeClick}>
              Home
            </li>
            <li
              className="text-6xl py-2 cursor-pointer"
              onClick={onAboutUsTextClick}
            >
              About Us
            </li>
            <li
              className="text-6xl py-2 cursor-pointer"
              onClick={onServicesTextClick}
            >
              Services
            </li>
            <li
              className="text-6xl py-2 cursor-pointer"
              onClick={onCareersTextClick}
            >
              Careers
            </li>
            <li
              className="text-6xl py-2 cursor-pointer"
              onClick={onButtonClick}
            >
              Get in touch
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

NavBarHome.propTypes = {
  className: PropTypes.string,

  /** Style props */
  navBarHomeWidth: PropTypes.string,
  navBarHomePosition: PropTypes.string,
  navBarHomeTop: PropTypes.string,
  navBarHomeLeft: PropTypes.string,
  navBarHomeAlignSelf: PropTypes.string,
};

export default NavBarHome;
